import { FC, useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import OrdersContainer from "../../components/containers/OrdersContainer";
import Modal from "../../components/molecules/Modal/Modal";
import { useDispatchEx, useSelectorEx } from "../../hooks/redux";
import { getOrderStatus } from "../../helpers/functions";
import { setStatusFilter, setCurrencyFilter, setMsgStatusFilter } from "../../redux/slices/orders/ordersSlice";
import { asyncGetCurrencyRatesAction } from "../../redux/slices/currencyRates/currencyRatesAction";
import { asyncDeleteOrderAction } from "../../redux/slices/orders/ordersAction";
import Button from "../../components/atoms/Button/Button";
import Select from "../../components/atoms/Select/Select";


const OrdersPage: FC = () => {
    const dispatch = useDispatchEx();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const { currencyCode, statusCode } = useParams();

    const { rates } = useSelectorEx(state => state.currencyRates);

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteOrderId, setDeleteOrderId] = useState<number | null>(null);

    const msgStatus = searchParams.get('msgStatus') || 'ALL';

    useEffect(() => {
        dispatch(asyncGetCurrencyRatesAction());
    }, [dispatch]);

    useEffect(() => {
        const currentCurrency = currencyCode || 'ALL';
        const currentStatus = statusCode || 'ALL';

        dispatch(setCurrencyFilter(currentCurrency));
        dispatch(setStatusFilter(currentStatus));
        dispatch(setMsgStatusFilter(msgStatus));
    }, [dispatch, currencyCode, statusCode, msgStatus]);

    const statusItems = [
        { value: 'ALL', name: 'Все статусы' },
        { value: '1', name: getOrderStatus(1).name },
        { value: '2', name: getOrderStatus(2).name },
        { value: '3', name: getOrderStatus(3).name },
        { value: '4', name: getOrderStatus(4).name },
        { value: '5', name: getOrderStatus(5).name },
    ];

    const activeCurrency = currencyCode || 'ALL';
    const activeStatus = statusCode || 'ALL';

    const getFilterUrl = (currency: string, status: string) => {
        let url = '/admin/orders';
        if (currency !== 'ALL' && status !== 'ALL') {
            url = `${url}/currency/${currency}/status/${status}`;
        } else if (currency !== 'ALL') {
            url = `${url}/currency/${currency}`;
        } else if (status !== 'ALL') {
            url = `${url}/status/${status}`;
        }
        return `${url}?msgStatus=${msgStatus}`;
    };

    const onMsgStatusChange = (status: string) => {
        setSearchParams({ msgStatus: status });
    };

    const onDeleteClick = (orderId: number) => {
        setDeleteOrderId(orderId);
        setDeleteModal(true);
    };

    const onDeleteConfirm = () => {
        if (deleteOrderId !== null) {
            dispatch(asyncDeleteOrderAction(deleteOrderId));
        }
        setDeleteModal(false);
        setDeleteOrderId(null);
    };

    const onDeleteCancel = () => {
        setDeleteModal(false);
        setDeleteOrderId(null);
    };

    return (
        <div className={'main-admin__content'}>
            <Modal
                active={deleteModal}
                onClose={onDeleteCancel}
                onAccept={onDeleteConfirm}
                onCancel={onDeleteCancel}
                controls={true}
                header={'Удаление заявки'}
            >
                <p>Вы уверены, что хотите удалить заявку #{deleteOrderId}?</p>
            </Modal>

            <div className="main-admin__header">
                <h1 style={{ color: "#ffffff", marginBottom: "20px" }}>Список заказов</h1>
            </div>

            <div className="main-admin__tabs">
                <div
                    className={`main-admin__tab ${msgStatus === 'ALL' ? 'active' : ''}`}
                    onClick={() => onMsgStatusChange('ALL')}
                >
                    Все заявки
                </div>
                <div
                    className={`main-admin__tab ${msgStatus === 'WAITING' ? 'active' : ''}`}
                    onClick={() => onMsgStatusChange('WAITING')}
                >
                    Ожидают ответа
                </div>
                <div
                    className={`main-admin__tab ${msgStatus === 'ANSWERED' ? 'active' : ''}`}
                    onClick={() => onMsgStatusChange('ANSWERED')}
                >
                    Отвеченные
                </div>
            </div>

            <div className="main-admin__filters">
                <div className="main-admin__filters-block" style={{ width: '100%', marginBottom: '30px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            <Button
                                type="link"
                                href={getFilterUrl('ALL', activeStatus)}
                                name="Все валюты"
                                className={activeCurrency === 'ALL' ? 'active' : ''}
                            />
                            {rates.map(rate => (
                                <Button
                                    key={rate.code}
                                    type="link"
                                    href={getFilterUrl(rate.code, activeStatus)}
                                    name={`${rate.name} ${rate.code}`.trim()}
                                    className={activeCurrency === rate.code ? 'active' : ''}
                                />
                            ))}
                        </div>

                        <div style={{ minWidth: '220px' }}>
                            <Select
                                items={statusItems}
                                defaultValue={activeStatus}
                                onChange={(val:any) => {
                                    navigate(getFilterUrl(activeCurrency, val));
                                }}
                            />
                        </div>

                    </div>
                </div>
            </div>

            <OrdersContainer onDelete={onDeleteClick} />
        </div>
    );
};

export default OrdersPage;